import React from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {connect} from 'react-redux';

/**
 * Filtro de selección de periodos
 */
class YearSelector extends React.Component {
  render() {
    const { value, handleChange, availablePeriods } = this.props;
    const yearsMenu = availablePeriods.map(year => {
      return (
        <MenuItem value={year} key={year}>
          {year}
        </MenuItem>
      );
    });
    return (
      <TextField
        id="outlined-select-year"
        select
        label="Período"
        value={value}
        onChange={event => {
          handleChange("year", event.target.value);
        }}
        margin="normal"
        variant="outlined"
        fullWidth
        disabled={availablePeriods.length === 0}
      >
        {yearsMenu}
      </TextField>
    );
  }
}

const mapStateToProps = ({data}) => ({
  availablePeriods : data.get("availablePeriods"),
});

export default connect(mapStateToProps, null)(YearSelector);



// WEBPACK FOOTER //
// ./src/components/filters/yearSelector.js